import React, { useState, useEffect } from 'react';

interface NavbarProps {
  onCartClick?: () => void;
}

const Navbar: React.FC<NavbarProps> = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <a 
            href="/"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE('/');
            }}
            className="flex items-center gap-2 sm:gap-3 cursor-pointer"
          >
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#d4af37] rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-file-text-line text-xl sm:text-2xl text-white"></i>
            </div>
            <span className="text-base sm:text-2xl font-bold text-gray-800 whitespace-nowrap">房仲專用買賣契約書</span>
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/');
              }}
              className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              首頁
            </a>
            <a
              href="/contracts"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/contracts');
              }}
              className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              契約範本
            </a>
            <a
              href="/faq"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/faq');
              }}
              className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              常見問題
            </a>
            <a
              href="/contact"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/contact');
              }}
              className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              聯絡我們
            </a>

            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeuJbYdeBMzieGnfn99LWF0ouQomCUDRkdqm8LYURvnotL5AA/viewform?usp=header"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-3 bg-[#d4af37] text-white font-bold rounded-lg hover:bg-[#c49d2e] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <i className="ri-file-list-3-line text-xl"></i>
              <span>訂購表單</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-[#d4af37] transition-colors cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4 bg-white">
            <div className="flex flex-col gap-4">
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/');
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer px-4 py-2"
              >
                首頁
              </a>
              <a
                href="/contracts"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/contracts');
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer px-4 py-2"
              >
                契約範本
              </a>
              <a
                href="/faq"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/faq');
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer px-4 py-2"
              >
                常見問題
              </a>
              <a
                href="/contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/contact');
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 hover:text-[#d4af37] font-medium transition-colors duration-300 cursor-pointer px-4 py-2"
              >
                聯絡我們
              </a>

              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSeuJbYdeBMzieGnfn99LWF0ouQomCUDRkdqm8LYURvnotL5AA/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 mx-4 px-6 py-3 bg-[#d4af37] text-white font-bold rounded-lg hover:bg-[#c49d2e] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
              >
                <i className="ri-file-list-3-line text-xl"></i>
                <span>訂購表單</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
